import axiosInstance from '../axiosInstance';

export const addWorkshopLike = async (workshopId) => {
  try {
    const response = await axiosInstance.post(`/workshops/${workshopId}/likes`);
    return response.data;
  } catch (error) {
    console.error('Add Workshop Like API Error:', error);
    throw error;
  }
};

export const removeWorkshopLike = async (workshopId) => {
  try {
    const response = await axiosInstance.delete(
      `/workshops/${workshopId}/likes`
    );
    return response.data;
  } catch (error) {
    console.error('Remove Workshop Like API Error:', error);
    throw error;
  }
};

export const getWorkshopLikeCount = async (workshopId) => {
  try {
    const response = await axiosInstance.get(
      `/workshops/${workshopId}/likes/count`
    );
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Get Workshop Like Count API Error:', error);
    throw error;
  }
};

export const getWorkshopLikeStatus = async (workshopId) => {
  try {
    const response = await axiosInstance.get(
      `/workshops/${workshopId}/likes/me`
    );
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Get Workshop Like Status API Error:', error);
    throw error;
  }
};

export const getMyLikedWorkshops = async (page = 0, size = 9) => {
  try {
    const response = await axiosInstance.get('/workshops/likes/all/me', {
      params: { page, size },
    });
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Get My Liked Workshops API Error:', error);
    throw error;
  }
};
